import React, { useState, useEffect } from 'react';
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { fixDate, fixDateEvent, getEventIcon, translateEvents } from '../../helpers/helperFunctions';
import { useTranslation } from "react-i18next";
import { MapTogglesProvider, useMapToggles } from '../Map/ToggleContext'; // Adjust the path as necessary
import NewButton from '../Buttons/NewButton';
import { useIsMobile } from '../../helpers/customHooks';
import { useNavigate } from 'react-router-dom';

const GeofenceRowNew = ( { geofence, setGeofenceToggle, editGeofence, index, geofenceLength } ) => {
	const { t } = useTranslation();
    const MOBILE = useIsMobile();
    const navigate = useNavigate();
    const { activeGeo, setActiveGeo } = useMapToggles();
    const [toggleActive, setToggleActive] = useState(false)
    const [deviceAmount, setDeviceAmount] = useState()


    const toggleFence = (event, id) => {
        event.stopPropagation();
        setGeofenceToggle(id)

    }

    useEffect(() => {
        setDeviceAmount(geofence?.deviceid?.length)
    }, [geofence])

    useEffect(() => {
        setToggleActive(geofence.selected)

    }, [geofence.selected])


    const focusGeofence = (event, geo) => {
        event.stopPropagation();
        setActiveGeo(geo)
        if(MOBILE){
            navigate("/map")
        }
    }
    
    return (
        <>
        <div className={`d-flex px-3 py-3 justify-content-between align-items-center cursor-pointer bg-white w-100`}>
            <div className="align-items-center justify-content-between d-flex w-100 overflow-hidden">
                <div className="d-flex flex-column w-75">
                    <p className='body bold primary text-truncate'>{geofence.name}</p>
                    {<p className="m-0 p-0">{deviceAmount} {t("geofence.devices", { count: deviceAmount })}</p>}
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <NewButton notext={true} icon={icons.target} className="full-rounded round-btn-30 bg-light-grey me-2" iconClass={"primary-icon"} onClick={(event) => focusGeofence(event, geofence)} />
                <NewButton className="bg-light-grey rounded15 grey-blue btn-30 p bold" onClick={() => editGeofence(geofence)}>{t("geofence.edit")}</NewButton>
            </div>
        </div>
        <hr className={`m-0 p-0 event-divider bg-light-grey ${index === geofenceLength - 1 ? "d-none" : "" }`} />
        </>
    )
}

export default GeofenceRowNew;